import { selectCurrentUser } from "../api/auth/authSlice";
import { useSelector } from "react-redux";
import { ProfileOptionsMenu } from "./UtilitiesComponents/ProfileOptionsMenu";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import { ArrayRoutes } from "../AppRoutes";

export function TopBar() {
    const location = useLocation();
    const { pathname } = location;
    const user = useSelector(selectCurrentUser);
    let nombre = user ? user.nombre : "Sin nombre";
    let role = user ? user.role : "Sin rol";
    const [appSection, setAppSection] = useState<string>();

    useEffect(() => {
        const splitedRoute = pathname.split("/")
        const currentSection = splitedRoute.length > 1
            ? `/${splitedRoute[1]}` : "/";
        const currentRoute = ArrayRoutes.find((route) => route.home.path === currentSection);
        if(currentRoute)
            setAppSection(currentRoute.nameSection);
    }, [location]);

    return (
        <div className="w-full h-14 border-b-2 border-gray-300 flex px-3 justify-between">
            <div className="flex justify-center items-center">
                <p className="text-lg font-semibold">{appSection}</p>
            </div>

            <div className="flex items-center gap-2">
                <ProfileOptionsMenu />
                <div className="text-[13px]">
                    <p className="font-semibold">{nombre}</p>
                    <p>{role}</p>
                </div>
            </div>

        </div>
    );
}